import styled from '@emotion/styled';
import { Text } from '~/shared/components/Text';
import { Link } from '~/shared/components/Link';
import { breakpoints } from '~/theme';

export const Section = styled.div(({ theme }) => ({
    display: 'grid',
    gap: theme.space[3],
}));

export const StyledFilterWrapper = styled.div(({ theme }) => ({
    display: 'flex',
    gap: theme.space[2],
    alignItems: 'center',
}));

export const StyledSearchWrapper = styled.div(() => ({
    maxWidth: '250px',
}));

export const StyledText = styled(Text)((props) => ({
    whiteSpace: 'nowrap',
}));

export const StyledMonthText = styled(Text)((props) => ({
    whiteSpace: 'nowrap',
    textTransform: 'capitalize',
}));

export const TableCellLink = styled(Link)(({ theme }) => ({
    '--svg-width': theme.space[4],
    color: theme.colors.brandBlue,
    fontSize: theme.fontSizes.guinea,
    fontWeight: theme.fontWeights.medium,
    position: 'relative',
    textAlign: 'left',
    span: {
        span: {
            marginLeft: '0px',
        },
    },

    ['svg']: {
        width: 'var(--svg-width)',
    },
    '&:after': {
        content: '""',
        position: 'absolute',
        right: 'var(--svg-width)',
        bottom: 2,
        height: '1px',
        width: 'calc(100% - var(--svg-width))',
        backgroundColor: theme.colors.brandBlue,
    },
    '&:hover:after, &:active:after, &:focus:after': {
        width: '0%',
        transition: 'width 0.3s ease-in-out',
    },
    '&:hover, &:active, &:focus': {
        textDecoration: 'none',
    },
}));

export const SkeletonSpacer = styled.div(() => ({
    height: 2,
}));

export const Footer = styled.div(({ theme }) => ({
    position: 'relative',
    marginTop: theme.space[4],
}));

export const PageSetter = styled.div(({ theme }) => ({
    display: 'none',
    [breakpoints.md]: {
        height: '100%',
        position: 'absolute',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        gap: theme.space[1],
    },
}));

export const Pagination = styled.div(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: theme.space[6],
}));
